export const ANIMALS = [
  {
    key: 'cow',
    maxLevel: 11,
    audioDuration: 300,
    winSoundDelay: 1200,
    hatPosition: {
      x: 0.69,
      y: 0.02,
    },
  },
  {
    key: 'goat',
    maxLevel: 10,
    pointsRequired: 5,
    audioDuration: 300,
    winSoundDelay: 1200,
    hatPosition: {
      x: 0.25,
      y: 0.06,
    },
  },
  {
    key: 'fox',
    maxLevel: 10,
    pointsRequired: 50,
    audioDuration: 300,
    winSoundDelay: 200,
    hatPosition: {
      x: 0.32,
      y: 0.04,
    },
  },
];

export const HATS = [
  {
    key: 'halloween',
    width: 134 / 300,
    test: () => {
      const d = new Date();
      return d.getMonth() === 9 && d.getDate() === 31;
    },
  },
  {
    key: 'christmas',
    width: 75 / 300,
    test: () => {
      const d = new Date();
      return d.getMonth() === 11 && d.getDate() === 25;
    },
  },
  {
    key: 'newYear',
    width: 61 / 300,
    test: () => {
      const d = new Date();
      return (d.getMonth() === 11 && d.getDate() === 31)
        || (d.getMonth() === 0 && d.getDate() === 1);
    },
  },
];

export const PAGE_WELCOME = 'PAGE_WELCOME';
export const PAGE_GAME = 'PAGE_GAME';
export const PAGE_CONGRATULATIONS = 'PAGE_CONGRATULATIONS';
export const PAGE_UNSUPPORTED = 'PAGE_UNSUPPORTED';

export const PAGES = [
  PAGE_WELCOME,
  PAGE_GAME,
  PAGE_CONGRATULATIONS,
  PAGE_UNSUPPORTED,
];

export const STORAGE_KEY = 'ftic_data';

export const FIND_RADIUS = 40;

export const TWEET_TEXT = '🐮 cow cow cow cow COW COW! COW! COW!! www.FindTheInvisibleCow.com by @scriptist';



// WEBPACK FOOTER //
// ./src/constants.js